import { Component, Input } from '@angular/core';

@Component({
    selector: 'admin-footer',
    template: require('./partials/admin-footer.component.html'),
})
export class AdminFooterComponent {

    constructor() {
    }
    
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-footer.component.ts